import React , {useEffect, useState}from 'react';
import { Image , Icon, GridRow , Grid, Popup,Button, Label, LabelDetail } from 'semantic-ui-react';
import {map } from "lodash"
import {Link, Switch} from "react-router-dom"
//import { useQuery } from '@apollo/client';
//import { GET_SAM } from '../../../gql/publication';
import fly300 from "../../../../asets/png/oferta.png"
import ModalBasic from '../../../../components/ModalBasic/ModalBasic';
import Price from '../../../../components/Publications/public/pricefed/Price';
import TitleEx from "../../FedExterior/TitleEx/TitleEx"
//import Footer from "../Footer/Footer"


//import WhatSend from '../WhatSend';




import "./FedOfert.scss";

export default function FedCategory(props) {

  const {publication} = props;
  const [showModal, setShowModal] = useState (false);
  const [publicationSelect, setPublicationSelect ] = useState (null);
  //const {data, loading,startPolling,stopPolling }= useQuery (GET_SAM);
  const [titleModal, setTitleModal] = useState ("")
  const [childrenModal, setChildrenModal] = useState (null) 
   





  /*if (loading) return null;
  const {getSample} = data;
  
  
*/

console.log (publication)

  return (

    <>

<div className='feedOfert' mobile = {16}  computer = {16}>



        {map (publication,(publication, index) => (
          <div key = {index} className = "feedOfert_boxOfert">
            
              <div className='feed_boxOfert'>
              
              <TitleEx publication={publication} publi ={publication.title} />
               </div>

               <div className='feed_box_precioOfert' mobile={16}>
   
               
            </div>
            <Link to = {`/Publication/${publication._id}`}>
<div class="ui fluid image">  <a class="ui yellow left corner label">
        <Icon name="certificate"/>

      </a>
      
      <Image src={publication.file}/>
    </div>
            </Link>

   
  

            <div className='feedOfert_ubicOfert' mobile={16}>
            <Label as='a' color='red' tag>💲{publication.precio} ❌
    </Label>

    <Popup
    content={publication.area}
    on='click'
    pinned
    trigger={<Icon name='map marker alternate' color='red' size='large' circular />}
  />      


              
   <Label as='a' color='teal' image>
      <img src={fly300} />💲 {publication.ofertPre} ✔️
   
    </Label>
    
    


    
            </div>
           
            </div>

        ))}
   
    </div>
    
</>
  
  
 ) 
  
  };
